import { Pipe, PipeTransform } from '@angular/core';
import { DocumentStatus, DocumentStatuses, SelectOption } from '@fleet-beat/core';

@Pipe({
  name: 'documentStatusPipe',
})
export class DocumentStatusPipe implements PipeTransform {
  transform(value: DocumentStatus): unknown {
    if (!value) return null;
    return DocumentStatuses.find((status: SelectOption) => status.value === value).label;
  }
}
